import { FORM_FIELDS } from '../constants/form.js';
import { AMOUNT_LIMITS, PURPOSE_SOURCE_VALUES, PERIOD_SOURCE_VALUES } from '../constants/sources.js';
import '../libs/yup.js';
import { formatNumber } from './fomatters.js';
import { pick } from './index.js';
import * as yup from 'yup';

var validators = function (options) {
    var _a;
    if (options === void 0) { options = {}; }
    var _b = options.amountMin, amountMin = _b === void 0 ? AMOUNT_LIMITS.MIN : _b, _c = options.amountMax, amountMax = _c === void 0 ? AMOUNT_LIMITS.MAX : _c, _d = options.purposes, purposes = _d === void 0 ? Object.values(PURPOSE_SOURCE_VALUES) : _d, _e = options.periods, periods = _e === void 0 ? Object.values(PERIOD_SOURCE_VALUES) : _e;
    return _a = {},
        _a[FORM_FIELDS.PURPOSE] = yup.string().required().oneOf(purposes),
        _a[FORM_FIELDS.PERIOD] = yup.string().required().oneOf(periods),
        _a[FORM_FIELDS.AMOUNT] = yup
            .number()
            .required()
            .integer()
            .min(amountMin, "\u0421\u0443\u043C\u043C\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430 \u043E\u0442 ".concat(formatNumber(amountMin)))
            .max(amountMax, "\u0421\u0443\u043C\u043C\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430 \u0434\u043E ".concat(formatNumber(amountMax))),
        _a;
};
var getValidationSchema = function (pickedFields, options) {
    return yup.object(pick(validators(options), pickedFields));
};

export { getValidationSchema };
//# sourceMappingURL=validators.js.map
